export enum ItemClickHandlerType {
  DEFAULT = 'default',
  RANGE_SELECT = 'rangeSelect',
  MULTI_SELECT = 'multiSelect'
}
